//@flow
export const GET_TASK_CATEGORIES='GET_TASK_CATEGORIES';
export const TASK_REDUCER_COMMON_ERROR='TASK_REDUCER_COMMON_ERROR';
export const SELECT_TASK_CATEGORY='SELECT_TASK_CATEGORY';
export const TASKS_LIST_UI_ACK='TASKS_LIST_UI_ACK';
export const REFRESH_TASKS_LIST='REFRESH_TASKS_LIST';
export const TASK_SELECT='TASK_SELECT';
export const TASK_SELECTED='TASK_SELECTED';
export const TASK_CANCEL='TASK_CANCEL';
export const TASK_ACCEPT='TASK_ACCEPT';
export const TASK_COMPLETED='TASK_COMPLETED';
export const TASK_ACCEPT_ERROR='TASK_ACCEPT_ERROR';
export const TASK_CAN_RESUME='TASK_CAN_RESUME';
export const TASK_ACCEPT_RESUME='TASK_ACCEPT_RESUME';
export const SET_WAITING='SET_WAITING'


// WEBPACK FOOTER //
// ./src/redux/tasks/actionTypes.js